import { ActionType } from "../action-types/type";

import AuthService from "../../services/authService";
import { Dispatch } from "redux";
import { AuthAction } from "../actions/index";
import { messageReducer } from "../reducers/message";

export const register =
  (
    username: string,
    password: string,
    role: string,
    isAccountNonExpired: number,
    isAccountNonLocked: number,
    isCredentialsNonExpired: number,
    isEnabled: number
  ) =>
  (dispatch: Dispatch<AuthAction>) => {
    return AuthService.register(
      username,
      password,
      role,
      isAccountNonExpired,
      isAccountNonLocked,
      isCredentialsNonExpired,
      isEnabled
    ).then(
      (response) => {
        dispatch({
          type: ActionType.REGISTER_SUCCESS,
        });

        dispatch({
          type: ActionType.SET_MESSAGE,
          payload: response.data.message,
        });
        return Promise.resolve();
      },
      (error) => {
        const message: string =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        dispatch({
          type: ActionType.REGISTER_FAIL,
        });

        dispatch({
          type: ActionType.SET_MESSAGE,
          payload: message,
        });
        return Promise.reject();
      }
    );
  };

export const login = (data: any) => (dispatch: Dispatch<AuthAction>) => {
  return dispatch({
    type: ActionType.LOGIN_SUCCESS,
    payload: { user: data },
  });
};

export const loginFailed = () => (dispatch: Dispatch<AuthAction>) => {
  return dispatch({
    type: ActionType.LOGIN_FAIL,
  });
};

export const messageAction =
  (message: any) => (dispatch: Dispatch<AuthAction>) => {
    return dispatch({
      type: ActionType.SET_MESSAGE,
      payload: message,
    });
  };

export const updateUserRoles =
  (data: any) => (dispatch: Dispatch<AuthAction>) => {
    return dispatch({
      type: ActionType.UPDATE_USER_ROLES,
      payload: { roles: data.roles },
    });
  };

// export const login =
// (username: string, password: string) => (dispatch: Dispatch<AuthAction>) => {
//   return AuthService.login(username, password).then(
//     (data: any) => {
//       dispatch({
//         type: ActionType.LOGIN_SUCCESS,
//         payload: { user: data },
//       });
//       return Promise.resolve(data);
//     },
//     (error: any) => {
//       const message =
//         (error.response &&
//           error.response.data &&
//           error.response.data.message) ||
//         error.message ||
//         error.toString();

//       dispatch({
//         type: ActionType.LOGIN_FAIL,
//       });

//       dispatch({
//         type: ActionType.SET_MESSAGE,
//         payload: message,
//       });

//       return Promise.reject();
//     }
//   );
// };

export const logout = () => (dispatch: Dispatch<AuthAction>) => {
  AuthService.logout();
  return dispatch({
    type: ActionType.LOGOUT,
  });
};
